import React from 'react';
import { createRoot } from 'react-dom/client';
import SinglePage from './components/SinglePage';
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import './index.css';


// --- React 19/18 Modern Root API ---

// 2. Find the root DOM element
const container = document.getElementById('root');

// --- FIX: Check for null to satisfy TypeScript and ensure runtime safety ---
if (!container) {
  throw new Error("Root element with ID 'root' not found in the document.");
}

// 3. Create a Root instance using createRoot(container)
const root = createRoot(container);

// 4. Call render() on the Root instance
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SinglePage />} />
        <Route path="/feed" element={<SinglePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
